module.exports = __webpack_public_path__ + "img/duanmian.5fc68567.png";